/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum CustomJSONTypeEnum {
    POLICY = 1,
    CANCEL = 2,
    CERTIFICATE = 3,
    WAIVER = 4,
    PAYROLL_REPORT = 5,
    INVOICE = 6,
    INCIDENT_REPORT = 7,
    CLAIM = 8,
    AUDIT = 9,
    ENDORSEMENT = 10,
    BATCH = 11,
}
